import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import '../assets/css/style.css';
import '../assets/css/bootstrap.css';
import api from "../api/axios";

const Login = () => {
  const history = useHistory();
  const [user, setUser] = useState({});
    const [showPassword, setShowPassword] = useState(false);
  const handleChange = ({ target }) => {
    const name = target && target.name;
    const value = target && target.value;
    setUser({ ...user, [name]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await api.post(
      "/users/admin_login",
      user
    );
    if (response) {
      localStorage.setItem("user_data", JSON.stringify(response.data.user));
      toast.success("User Login Success");
      setUser({});
      history.push("/");
    }
  };
  return (
    <div style={{background:"#f2f7fb"}}>
    <div className="wrap-login-page">
      <div className="flex-grow flex flex-column justify-center gap30">
        <Link to="index.html" id="site-logo-inner"></Link>
        <div className="login-box">
          <div>
            <h3 style={{fontSize: "22px",fontWeight: "700",width: "50%"}}>Login to account</h3>
            <div className="body-text">
              Enter your email & password to login
            </div>
          </div>
          <form className="form-login flex flex-column gap24">
            <fieldset className="email">
              <div className="body-title mb-10">
                Email address <span className="tf-color-1">*</span>
              </div>
              <input
                className="flex-grow"
                type="email"
                placeholder="Enter your email address"
                name="email"
                tabindex="0"
                value={user.email}
                aria-required="true"
                required=""
                onChange={handleChange}
              />
            </fieldset>
             <fieldset className="password">
                <div className="body-title mb-10">
                  Password <span className="tf-color-1">*</span>
                </div>
                <input
                  className="password-input"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  name="password"
                  tabindex="0"
                  value={user.password}
                  aria-required="true"
                  required=""
                  onChange={handleChange}
                />
                <span
                  className="show-pass"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "53%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? (
                    <i className="icon-eye-off hide"></i>
                  ) : (
                    <i className="icon-eye"></i>
                  )}
                </span>
              </fieldset>
            <div className="flex justify-between items-center">
              <div className="flex gap10">
                <input className="" type="checkbox" id="signed" />
                <label className="body-text" for="signed">
                  Keep me signed in
                </label>
              </div>            
            </div>
            <Link
              to="#"
              className="tf-button w-full"
              onClick={(e) => handleSubmit(e)}
            >
              Login
            </Link>
          </form>         
        </div>
      </div>
    </div>
    </div>
  );
};

export default Login;
